<template>
  <div class="profile-page">
    <p class="page-title">最新动态</p> 
    <el-row :gutter="20">
      <el-col :span="18">
        <v-card>
         <div class="new-page-wp">
           <h2 class="new-page-title">{{Detail.title}}</h2>
           <p class="new-page-text1"><span>媒体来源：{{Detail.author}}</span><span>{{Detail.creationTime | date('YYYY-MM-DD')}}</span></p>
           <div class="ql-container ql-snow">
              <div class="ql-editor">
                <div v-html="Detail.body"></div>
              </div>
          </div>
           <div class="new-page-btn">
              <router-link to="/Articles">
                <el-button :plain="true" type="info">返回</el-button>
              </router-link> 
            </div>
         </div>
        </v-card>
      </el-col>
      <el-col :span="6">
        <v-card>
          <div>
            <p>相关内容</p>
            <div class="articleBoxHead">
              <router-link :to="{name: 'ArticleListPage', params: {tabs: 'company'}}">
                <el-button type="info" :plain="true" size="small">公司新闻</el-button>
              </router-link>
              <router-link :to="{name: 'ArticleListPage', params: {tabs: 'industry'}}">
                <el-button type="info" :plain="true" size="small">行业新闻</el-button>
              </router-link>
              <router-link :to="{name: 'ArticleListPage', params: {tabs: 'media'}}">
                <el-button type="info" :plain="true" size="small">媒体关注</el-button>
              </router-link>
            </div>
          </div>
          <div class="articleLine" @click="articleChange(item.id)" v-for="item in NewsList" :key="item.id">
            <span class="articleLineTitle" >{{item.title}}</span>
            <span class="articleLineDate">{{item.creationTime | date('YYYY-MM-DD')}}</span>
          </div>
        </v-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import vCard from '@/components/common/Card'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  data() {
    return {
      Detail: {},
      NewsList: [],
    }
  },
  created() {
    this.getDetail()
    this.initArticles()
  },
  methods: {
    getDetail() {
      this.$http.get(`${process.env.API_HOST}/Article/GetDetail?key=${this.$route.params.id}`).then(({ data }) => {
        this.Detail = data
      }).catch((error) => {
        console.error(error)
      })
    },
    articleChange(id) {
      this.$router.push(`/Article/${id}`)
      this.getDetail()
    },
    initArticles() {
      this.$http.get(`${process.env.API_HOST}/Article`, {
        params: {
          index: 1,
          size: 5,
        },
      }).then((data) => {
        var result = data.data
        this.NewsList = result.list
        this.total = result.total
      }).catch((error) => {
        this.$alert(error.message)
      })
    },
  },
  computed: {
    routePath() {
      return this.$route.path
    },
  },
  components: {
    vCard,
  },
}
</script>

<style lang="less" scoped>
.profile-page {
  padding-left: 10px;
  padding-right: 10px;
  .articleLine {
    border-bottom: solid 1px #ccc;
  }
  .articleLine:hover {
    cursor: pointer;
  }
}
.page-title1{font-size: 18px;padding-bottom: 20px;}
.contract {
  margin-top: 20px;
  padding: 30px;
  .row {
    height: 44px;
    font-size: 12px;
    &:last-child {
      margin-top: 20px;
    }
    p {
      margin: 0;
    }
    .fa {
      line-height: 44px;
      font-size: 28px;
      color: #20a0ff;
    }
  }
}

.menu {
  background-color: transparent;
  .menu-item {
    height: 46px;
    line-height: 46px;
    background-color: transparent;
    border-left: 4px solid transparent;
    color: #43484d;
    &.is-active {
      background-color: #e5e9f2;
      border-left: 4px solid #707070;
      color: #43484d;
    }
    .fa {
      margin-right: 10px;
    }
  }
}
</style>

<style lang="less">
.profile-page {
    .newsListTopBlock {
      padding-top: 20px;
    }
    .newsListRow {
      margin-bottom: 20px;
      margin-bottom: 20px;
      padding-bottom: 15px;
    .textTitle {
      font-weight: bold;
    }
    .textInfo {
      font-size: 12px;
      color: #999;
    }
    .textEllipsis {
      padding-top: 15px;
      color: #666;
      font-size: 12px;
      line-height:20px;
      width:639px;
      height:72px;
      display:-webkit-box !important;
      overflow:hidden;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:3;
    }
  }
  
  .btn {
    background-color: #c8e7fd;
    width: 120px;
    height: 36px;
    font-size: 12px;
  }
  .el-button {
    border:none;
    border-color:#c8e7fd;
  }
  .articleLineTitle {
    margin: 5px 0;
    font-size: 14px;
    flex: auto;
    color: #222;
    text-decoration: none;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .articleLineDate {
    width:100%;
    margin-bottom: 10px;
    font-size:12px;
    color:#999;
    text-decoration: none;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .articleLineBody{
    height:130px;
    text-decoration: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.new-page-title{
  font-size: 20px;
  padding-top: 20px;
}
.new-page-text1{
  color:#999;
  padding-bottom: 20px;
  padding-top: 5px;
  line-height: 2em;
  span{padding-right:10px;}
}
.new-page-text2{
  line-height: 2em;
  color:#999;
  padding-top: 30px;
  p{text-indent: 2em;}
}
.new-page-btn{
  text-align: center;
  padding: 20px 0;
  .is-plain{padding: 10px 40px;}
}
.ql-container.ql-snow {
  border: 0 !important;
}
.articleBoxHead {
  padding:10px;
  height: 60px;
  border-bottom: solid 1px #ccc;
}
</style>



// WEBPACK FOOTER //
// ArticleDetail.vue?56bda52e